export const FETCH_MARUTI_SYNC = 'FETCH_MARUTI_SYNC'
export const FETCHED_MARUTI_SYNC = 'FETCHED_MARUTI_SYNC'
export const SEARCH_MARUTI_SYNC = 'SEARCH_MARUTI_SYNC'
export const STORE_SEARCH_MARUTI_RESULT_SYNC = 'STORE_SEARCH_MARUTI_RESULT_SYNC'
export const REPOST_REDISID_SYNC = 'REPOST_REDISID_SYNC'
export const FILTER_ITEMS_SYNC = 'FILTER_ITEMS_SYNC'
export const PULL_OLD_SYNC_STATUS_MARUTI = 'PULL_OLD_SYNC_STATUS_MARUTI'
export const FETCHED_PULL_OLD_SYNC_STATUS_MARUTI = 'FETCHED_PULL_OLD_SYNC_STATUS_MARUTI'
export const SYNC_UTD_MARUTI = 'SYNC_UTD_MARUTI'
export const SYNCED_UTD_MARUTI = 'SYNCED_UTD_MARUTI'
export const NOTIFICATION_DONE_ITEM_MARUTI ='NOTIFICATION_DONE_ITEM_MARUTI'

